console.log("Working");

function updateProductCount() {
    // Query
    const progressElement = document.querySelector('.item-counter-progress');
    const progressLine = document.querySelector('.item-counter-progress-line');
    const pageCountText = document.querySelector('.page-count-text');
    const pageCountContainer = document.querySelector('.page-count-container');
    const viewMoreButton = document.querySelector('.view-more-button');
    const productBlocks = document.querySelectorAll('.filters-adjacent > .product-grid > .infinitescroll-item.product-block').length;
    const itemCounter = document.querySelector('.item-counter');

    // And change
    itemCounter.textContent = productBlocks;
    progressElement.value = productBlocks;
    progressLine.style.width = `${(progressElement.value / progressElement.max) * 100}%`;

    // And hide if value == max.
    if (progressElement.value == progressElement.max) {
        viewMoreButton.hidden = true;
        // itemCounter.hidden = true;
        // progressElement.hidden = true;
        // pageCountText.hidden = true;
        // pageCountContainer.hidden = true;
    }
    else {
        itemCounter.hidden = false;
        // progressElement.hidden = false;
        pageCountText.hidden = false;
        viewMoreButton.hidden = false;
        pageCountContainer.hidden = false;
    }
}

// Watch for changes in the product-grid container
const productGrid = document.querySelector('.filters-adjacent > .product-grid');
if (productGrid) {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            updateProductCount();
        }
        });
    });

    observer.observe(productGrid, { childList: true, subtree: true });
}

// Initial count update after page load
document.addEventListener('DOMContentLoaded', updateProductCount);